<template>
  <div class="forget_account">
    <div class="content_a">
      <span>账号：</span>
      <el-input
        placeholder="请输入账号"
        prefix-icon="el-icon-user"
        class="phone"
        clearable
        v-model.trim="userName"
      >
      </el-input>
    </div>
    <div class="content_a">
      <span>验证码：</span>
      <el-input
        placeholder="请输入验证码"
        class="input2"
        v-model.trim="VerifyCode"
      >
      </el-input>
      <!-- <div class="vertify_code">{{ verifynum }}</div> -->
      <img :src="verifynum" alt="" />
      <div class="vertify_c" @click="changeVerifyNum">看不清楚，换一张</div>
    </div>
    <el-button type="primary" class="forget_btn" @click="next"
      >下一步</el-button
    >
  </div>
</template>

<script>
import forget from "@/api/forgetpassword";
import qs from "qs";
export default {
  data() {
    return {
      userName: "", //账号手机号
      VerifyCode: "", //输入验证码
      verifynum: 0, //图片验证码
      allsopeguid: "",
    };
  },
  props: ["cutcom"],
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    loadImage_file(blob) {
      //二进制流转换图片
      console.log(blob);
      var fr = new FileReader();
      fr.readAsDataURL(blob.raw);
      fr.onload = function (e) {
        // var preview=document.getElementById('preview');
        console.log(fr.result);
        this.verifynum = e.target.result;
      };
    },
    filebuffe(imgbuffe) {
      return (
        "data:image/png;base64," +
        btoa(
          new Uint8Array(imgbuffe.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        )
      );
    },
    async changeVerifyNum() {
      //请求图片验证码
      // this.verifynum = this.randomNum(1000, 9999);
      let res = await forget.getguidCode();
      let parmas = {
        guid: res.data.Data.guidCode,
      };
      let imgs = await forget.CreateVerificationCode(qs.stringify(parmas));
      this.verifynum = this.filebuffe(imgs);
      console.log(this.verifynum);
      this.$emit("sendguid", res.data.Data.guidCode);
      this.allsopeguid = res.data.Data.guidCode;
      console.log(this.allsopeguid);
    },
    async next() {
      let phonereg = /^1[3|4|5|7|8][0-9]\d{4,8}$/; //手机号正则式
      if (phonereg.test(this.userName)) {
        console.log("通过校验");
        let parmas = {
          phone: this.userName,
          guidCode: this.$parent.guidcode,
          VerifyCode: this.VerifyCode,
        };
        let resa = await forget.checkPhoneAndVerifyCode(parmas);
        console.log(resa);
        if (resa.data.Status == 200) {
          this.$emit("sendguida", resa.data.Data.guid, this.userName);
          this.cutcom(1);
        } else {
          this.changeVerifyNum();
          this.$message({
            //手机号正确，验证码不对的时候
            showClose: true,
            message: "验证码不对，重新输入",
            type: "error",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "手机号输入格式不对",
          type: "error",
        });
      }
      // this.cutcom(1);
    },
  },
  async created() {
    this.changeVerifyNum();
    // let res = await forget.getguidCode();
    // let parmas = {
    //   guid: res.data.Data.guidCode,
    // };
    // let imgs = await forget.CreateVerificationCode(qs.stringify(parmas));
    //   this.verifynum = this.filebuffe(imgs);
    console.log(this.allsopeguid);
    // this.$emit("sendguid", this.allsopeguid);
  },
};
</script>

<style lang="less" scoped>
.forget_account {
  width: 540px;
  height: 300px;
  // background: red;
  .content_a {
    display: flex;
    align-items: center;
    //  justify-content: center;
    margin-top: 40px;
    span {
      width: 100px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
    .phone {
      width: 400px;
    }
  }
}
.input2 {
  width: 200px;
}
.vertify_code {
  width: 90px;
  height: 35px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  opacity: 1;
  border-radius: 100px;
  border: 1px solid rgb(202, 199, 199);
  background-color: white;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  line-height: 35px;
  color: #1890ff;
}
.vertify_c {
  width: 140px;
  margin-left: 10px;
  color: #1890ff;
  font-weight: 400;
  cursor: pointer;
}
.forget_btn {
  width: 300px;
  margin: 40px 150px;
}
</style>
